<template>
  <div>
    <folder></folder>
  </div>
</template>
<script>
  import folder from '../../components/folder/folder.vue'
  export default{
    components:{
      folder
    },
    data(){
      return{

      }
    }
  } 
</script>